var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ToolbarItemContainer,{attrs:{"iconFile":_setup.handleIcon(),"title":_setup.handleTitle(),"needDialog":false,"iconWidth":_setup.isUniFrameWork ? '32px' : '21px',"iconHeight":_setup.isUniFrameWork
      ? _setup.props.videoSourceType === 'album'
        ? '20px'
        : '25px'
      : '18px'},on:{"onIconClick":_setup.onIconClick}},[_c('div',{class:['video-upload', !_setup.isPC && 'video-upload-h5']},[_c('input',{ref:"inputRef",attrs:{"title":"视频","type":"file","data-type":"video","accept":"video/*"},on:{"change":_setup.sendVideoInWeb}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }